module.exports = __webpack_public_path__ + "static/media/ft2-2.494e9c70.jpg";